import { getPaymentCalculatorDiscountPromotion } from "../../../../helpers/tools";

/*
    Do not forget, when applying discounts using percentages, 
    the rule is to use the largest percentage, it is not cumulative. 
    That is, if we have a 5% discount but we also have another discount of 10%, 
    then the final discount is 10%, not 15%.

*/
export function asianAllOthersCountriesDiscountsHorticulture(
  data,
  paymentType,
  courses,
  specialCases
) {
  for (let i = 0; i < courses.length; i++) {
    const course = courses[i];
    // Default finalTuition, change if have discount
    course.finalTuition = course?.tuition;
    course.discountsApplied = [];
  }

  console.debug("Courses after discounts were applied:", courses);
}
